import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { connect } from 'react-redux'
import { getUserData, getPersonalData } from '../../../redux/actions/items.js'
import MaskedInputWrap from '.././maskedInputWrap.jsx'
import Notification from '../Notification/index.jsx'
import DataProtectionButtons from './dataProtectionButtons.jsx'
import uuidv3 from 'uuid/v3'

class dataProtection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            tfa_code: '',
            tfa_code_requested: false,
            notification: {},
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    componentDidMount() {
        let { tfaCodeRequestRequired } = this.props
        if (!tfaCodeRequestRequired) {
            this.nameInput.inputElement.focus()
        }
        this.props.getStatus()
    }

    componentDidUpdate(prevProps, prevState) {
        let { wrongCode } = this.props

        if (wrongCode === 'wrong_2fa_code') {
            this.changeNotificationStatus({
                type: 'error',
                description: 'Wrong code',
            })
            this.props.UserData('CLEANING_USER_STATE')
        }
    }

    render() {
        let { tfa_code_requested } = this.state
        let { tfaCodeRequestRequired, tfaType } = this.props

        return (
            <div className="data-protection">
                <div>
                    <div className="data-protection__icon">
                        <FontAwesomeIcon
                            className="profile__icon profile__icon_protection"
                            icon={'shield-alt'}
                        />
                    </div>
                    <p className="data-protection__title">
                        {this.translation['Your data is protected']}
                    </p>
                    <p className="data-protection__typeTFA">
                        {this.translation['Two-factor authentication type']}:{' '}
                        <span>{tfaType}</span>
                    </p>
                    {((tfaCodeRequestRequired && tfa_code_requested) ||
                        (!tfaCodeRequestRequired && !tfa_code_requested)) && (
                            <p className="data-protection__info">
                                {
                                    this.translation[
                                        'To display data, enter the code'
                                    ]
                                }
                            </p>
                        ) && (
                            <MaskedInputWrap
                                type={'tfa_code'}
                                value={this.state.value}
                                reference={ref => this.inputFocus(ref)}
                                changeValue={this.changeTFAСode}
                                placeholderChar={'\u2000'}
                                placeholder={
                                    tfaCodeRequestRequired
                                        ? `${
                                              this.translation[
                                                  'Enter the received code'
                                              ]
                                          }...`
                                        : `${
                                              this.translation[
                                                  'Enter the 2FA code'
                                              ]
                                          }...`
                                }
                            />
                        )}
                    <DataProtectionButtons
                        tfa_code={this.state.tfa_code}
                        tfa_code_requested={this.state.tfa_code_requested}
                        tfaCodeRequestRequired={
                            this.props.tfaCodeRequestRequired
                        }
                        TFAcodeReceived={this.TFAcodeReceived}
                        checkButtonClicked={this.checkButtonClicked}
                    />
                    <Notification
                        notification={this.state.notification}
                        changeNotificationStatus={this.changeNotificationStatus}
                    />
                </div>
            </div>
        )
    }

    TFAcodeReceived = () => {
        let { tfaType = 'Email' } = this.props
        this.setState({
            tfa_code_requested: !this.state.tfa_code_requested,
        })
        this.changeNotificationStatus({
            type: 'success',
            description:
                tfaType.toLowerCase() === 'email'
                    ? 'Sent the code to your email'
                    : 'Sent the code to your phone number',
        })
        this.nameInput.inputElement.focus()
    }

    inputFocus = ref => {
        this.nameInput = ref
    }

    checkButtonClicked = () => {
        if (this.state.tfa_code.length !== 6) return null
        this.props.getPersonalData(this.state.tfa_code)
    }

    changeTFAСode = event => {
        this.setState({
            tfa_code: event.target.value.replace(/[^A-Z|0-9]/gi, ''),
        })
    }

    changeNotificationStatus = options => {
        let notification = {}

        if (Object.keys(options).length) {
            Object.keys(options).forEach(item => {
                notification[item] = options[item]
            })
            notification['uuid'] = uuidv3(
                Object.values(notification).join(''),
                uuidv3.URL
            )
        }

        this.setState({
            notification,
        })
    }
}

const mapStateToProps = state => {
    return {
        file: state.addFile,
        removeFile: state.removeFile,
        dataCollection: state.AddFiles,
    }
}

const mapDispatchProps = dispatch => {
    return {
        getUserData: () => dispatch(getUserData()),
        getPersonalData: code => dispatch(getPersonalData(code)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchProps
)(dataProtection)
